import { useContext } from "react";

import { BreadcrumbsContext } from "./BreadcrumbsContext";

export function useBreadcrumbs() {
  return useContext(BreadcrumbsContext);
}
